import React, { useMemo, useState } from 'react';
import { toCssDeclarationName } from '@/features/editor/widgets/shared/ai-editing-layout/inputs/shared/css-declarations';
import { InlineInputCardWrapper } from '@/features/editor/widgets/shared/ai-editing-layout/inputs/shared/shared';
import { SingleSelectInput } from '@/features/editor/widgets/shared/ai-editing-layout/inputs/shared/single-select-input';
import { DropdownInputOption } from '@/features/editor/widgets/custom-widget/inputs/shared/dropdown';
import {
  hasImportant,
  stripImportant,
  addImportantIfNeeded,
} from '@/features/editor/widgets/shared/ai-editing-layout/inputs/parsers';

export interface CssEnumInputProps {
  name: string;
  initialValue?: string;
  onChange?: (name: string, value: string) => void;
  options?: DropdownInputOption[];
}

export function CssEnumInput({
  name,
  initialValue,
  options,
  onChange,
}: CssEnumInputProps) {
  const displayName = useMemo(() => toCssDeclarationName(name), [name]);

  // Track if initial value had !important
  const [hadImportant] = useState(() => hasImportant(initialValue || ``));
  const cleanInitialValue = useMemo(
    () => stripImportant(initialValue || ``),
    [initialValue],
  );

  const initOption = useMemo(
    () => options?.find((option) => option.value === cleanInitialValue),
    [cleanInitialValue, options],
  );

  const onValueChanged = (value: DropdownInputOption) => {
    if (onChange) {
      const outputValue = addImportantIfNeeded(value.value, hadImportant);
      onChange(name, outputValue);
    }
  };

  return (
    <InlineInputCardWrapper>
      <span>{displayName}</span>
      <SingleSelectInput
        options={options}
        initialValue={initOption}
        onChange={onValueChanged}
      />
    </InlineInputCardWrapper>
  );
}
